<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
    <v-layout row wrap class="sub-tab-color mb-3">
      <v-flex offset-md1 md10>
        <v-tabs :value="caminho" slider-color="blue" class="sub-tab">
          <v-tab v-for="tab in (tabs !== null ? tabs : [])" :key="rota + tab.url" :ripple="false" :to="rota + tab.url">
            {{ tab.nome }}
          </v-tab>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-slide-x-transition mode="out-in">
      <div class="">
        <slot></slot>
        <router-view :class="loading ? 'blur' : 'blur confirmado'"></router-view>
      </div>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
export default {
  name: 'SubTabs',
  props: {
    tabs: {
      type: Array,
      default: null
    },
    nomeSessao: String
  },
  data () {
    return {
      rotaAtual: ''
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loadingMounted
    },
    rota () {
      let rota = this.$store.state.route.path
      rota = rota.split('/')
      return '/Painel/' + rota[2] + '/'
    },
    caminho () {
      return this.$store.state.route.path
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.sub-tab .v-tabs__container {
 background-color: #eaedf4 !important; 
}
.sub-tab li a{
  font-weight: 600;
  color: #5f6670!important
}
.sub-tab .tabs__item.tabs__item--active{
  color: #0063bb !important;
}
.sub-tab .tabs__slider.accent{
  background-color: #0063bb !important;
  border-color: #0063bb !important;
}
.no-transform,.sub-tab .tabs__item{
  text-transform: none!important;
}
.not-avaliable a{
  cursor: default!important;
}
.sub-tab .tabs__bar{
  background-color: transparent;
}
/*loading*/
.top-blur{
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top:0px;
  z-index: 1;
}
.confirmado.top-blur{
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.7s, visibility 1s;
}
.blur{
      filter: blur(1px);
}
.confirmado.blur{
  filter: blur(0px);
  transition: filter 0.1s;
}
</style>



// WEBPACK FOOTER //
// SubTabs.vue?fcb2bbb4